import React from "react";

import ACIconWrapper, { ACIconProps } from "./ACIconWrapper";

export default function ReturnIcon(props: ACIconProps) {
  return <ACIconWrapper component={IconSvg} {...props} />;
}

const IconSvg = () => {
  return (
    <svg
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M17.25 6C17.6642 6 18 6.33579 18 6.75V12C18 12.7293 17.7103 13.4288 17.1945 13.9445C16.6788 14.4603 15.9793 14.75 15.25 14.75H8.6599L10.7603 16.7004C11.0639 16.9823 11.0814 17.4568 10.7996 17.7603C10.5177 18.0639 10.0432 18.0814 9.73966 17.7996L6.23966 14.5496C6.08684 14.4077 6 14.2086 6 14C6 13.7914 6.08684 13.5923 6.23966 13.4504L9.73966 10.2004C10.0432 9.91855 10.5177 9.93613 10.7996 10.2397C11.0814 10.5432 11.0639 11.0177 10.7603 11.2996L8.6599 13.25H15.25C15.5815 13.25 15.8995 13.1183 16.1339 12.8839C16.3683 12.6495 16.5 12.3315 16.5 12V6.75C16.5 6.33579 16.8358 6 17.25 6Z"
        fill="currentColor"
      />
    </svg>
  );
};
